export default __webpack_public_path__ + "static/media/error.7502b3e6.svg";